import React from "react";
import { useNavigate } from "react-router-dom";
import "./Stone.css";
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const DeckFence = () => {
  const navigate = useNavigate();

  const goToQuoteForm = () => {
    sessionStorage.setItem("scrollToQuote", "true");
    navigate("/");
  };

  return (
    <div className="stone-page">
      <Header />
      {/* Hero Section */}
      <section className="stone-hero">
        <h1>Custom Deck & Fence Services</h1>
        <p>
          Build beautiful, functional outdoor living spaces with expertly crafted decks and fences.
        </p>
      </section>

      {/* Services Highlights */}
      <section className="stone-services">
        <div className="stone-card-grid">
          {[
            {
              title: "Wood & Composite Decks",
              description: "Durable, stylish deck installations for relaxing and entertaining.",
            },
            {
              title: "Privacy & Decorative Fencing",
              description: "Secure your space with fences that add style and privacy.",
            },
            {
              title: "Custom Railings & Stairs",
              description: "Beautiful finishes that match your home’s character.",
            },
            {
              title: "Deck & Fence Repairs",
              description: "Restore safety and appearance with expert repairs.",
            },
          ].map((item, i) => (
            <div className="stone-card" key={i}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Image Grid */}
      <section className="stone-gallery">
        {["deck.jpg", "deck0.jpg", "deck3.jpg"].map((img, i) => (
          <img
            key={i}
            src={`/images/${img}`}
            alt={`Deck and Fence project ${i + 1}`}
          />
        ))}
      </section>

      {/* CTA Section */}
      <section className="stone-cta">
        <p>
          Ready to upgrade your outdoor space with a new deck or fence? Let’s design something that lasts.
        </p>
        <button
          onClick={goToQuoteForm}
          style={{
            backgroundColor: "#2E7D32",
            color: "white",
            border: "none",
            padding: "12px 30px",
            fontSize: "1rem",
            borderRadius: "8px",
            cursor: "pointer", }} > Request an Estimate <span className="cta-arrow">→</span> </button>
      </section>
      <Footer />
    </div>
  );
};

export default DeckFence;
